import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SdgLogic, useStyles } from './Sdg.module';
import Popover from '@material-ui/core/Popover';

const Sdg = ({ sdgs = [] }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [info, setInfo] = useState('');
  const handlePopoverOpen = (info) => (event) => {
    setInfo(info);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setInfo('');
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Grid container className={classes.sdg}>
        <Grid item lg={1} md={1} sm={1} xs={12}></Grid>

        <Grid
          item
          lg={10}
          md={10}
          sm={10}
          xs={12}
          className={classes.sdgContaienr}
        >
          <Typography className={classes.titleImpact}>UN SDGs</Typography>

          <Grid container spacing={2}>
            {sdgs?.map((item, index) => (
              <Grid
                item
                lg={3}
                md={3}
                sm={3}
                xs={12}
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen(item.info)}
                onMouseLeave={handlePopoverClose}
                className={classes.sgDataRoot}
              >
                <Typography className={classes.sdgData}>{item.data}</Typography>
                <Typography className={classes.sdgTitle}>
                  {item.title}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
      </Grid>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>{info}</Typography>
      </Popover>
    </>
  );
};

export default Sdg;
